module.exports = __webpack_public_path__ + "img/barrage_prize_07.bd0107ae.png";